import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { PLANT_ITEM_NEW_API_BASE_URL } from 'plantItemNew/constants/plantItemConstants';
import { formattedJsonToSubmit } from 'plantItemNew/utils/PlantItemNewFormatHelper';

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const feesSlice = createSlice({
  name: 'fees',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFees.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getFees.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = 'succeeded';
      })
      .addCase(getFees.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

const apiUrl = `${PLANT_ITEM_NEW_API_BASE_URL}/fees`;

export const getFees = createAsyncThunk('fees/getFees', async (duration, { getState }) => {
  const { application, applicantDetails, holderDetails, plantItems, referenceData, declaration, privacyCollection } =
    getState();

  let data;

  try {
    data = formattedJsonToSubmit(
      application,
      duration,
      applicantDetails,
      holderDetails,
      plantItems,
      referenceData,
      declaration,
      privacyCollection,
    );
  } catch (error) {
    console.error(error);
    throw error;
  }

  const response = await axios.post(apiUrl, data, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  return response.data.response[0];
});

export const feesReducer = feesSlice.reducer;
